import React from "react";
import { createRoot } from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import "regenerator-runtime/runtime";
import "./assets/styles/style.css";
import "./assets/styles/style.scss";
import { setup } from "./core/date";
import { setup as logSetup } from "./logger.js";
import { default as rootSagas } from "./rootSagas";
import axiosSetup from "./services";

import "./rc-datepicker-override.css";
import "./rc-datepicker.css";

import { StrictMode } from "react";
import { Provider } from "react-redux";
import "./react-datepicker-override.scss";
import "./react-datepicker.min.css";
import { store } from "./redux";
import Main from "components/Main";
import AppGlobalStore from "./AppGlobalStore";

logSetup();
setup();

axiosSetup();
store.runSaga(rootSagas);
AppGlobalStore.setGlobalStore(store);

const container = document.getElementById("root");
const root = createRoot(container);
const renderApp = () => {
    return (
        <StrictMode>
            <Provider store={store}>
                <Main />
            </Provider>
        </StrictMode>
    );
};
root.render(renderApp());

